export default __webpack_public_path__ + "d10acf2473b28464dc883918ede0e0a0.png";